import React from 'react';
import { motion } from 'framer-motion';
import { Star, Heart } from 'lucide-react';
const testimonials = [{
  name: 'Camila R.',
  location: 'Buenos Aires',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80',
  quote: 'Nunca había cosido y ya hice 3 vestiditos para mi Coco. ¡Me re sirvió el paso a paso, es súper claro!'
}, {
  name: 'Valentina M.',
  location: 'CDMX',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80',
  quote: 'Empecé a vender por Instagram y ya tengo pedidos cada semana. Los moldes premium son una locura. ¡Gracias!'
}, {
  name: 'Sofía L.',
  location: 'Bogotá',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&q=80',
  quote: 'Los moldes son super claros, y los diseños son hermosos. Mi gatita está divina con su ropa nueva.'
}];
export function Testimonials() {
  return <section className="py-24 bg-brand-pink-light/20 relative overflow-hidden" data-id="element-246">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-249">
            Lo que dicen nuestras{' '}
            <span className="font-script text-brand-rose text-4xl md:text-5xl lowercase" data-id="element-250">
              clientas felices
            </span>{' '}
            💕
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-251">
          {testimonials.map((testi, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-soft-pink relative" data-id="element-252">
              <Heart className="absolute top-6 right-6 text-brand-pink-mid opacity-50" size={24} data-id="element-253" />

              <div className="flex items-center gap-4 mb-6" data-id="element-254">
                <img src={testi.image} alt={testi.name} className="w-16 h-16 rounded-full object-cover border-2 border-brand-pink-light" data-id="element-255" />
                <div data-id="element-256">
                  <h4 className="font-bold text-lg" data-id="element-257">{testi.name}</h4>
                  <p className="text-sm text-brand-brown/60" data-id="element-258">
                    {testi.location}
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-4" data-id="element-259">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-yellow-400 text-yellow-400" data-id="element-260" />)}
              </div>

              <p className="text-brand-brown/80 italic leading-relaxed" data-id="element-261">
                "{testi.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}